'use client';
import Link from 'next/link';
import Image from 'next/image';
import { PiArrowRight } from 'react-icons/pi';
import Pagination from './components/Pagination';
import { PostsGridProps } from '@/types/posts';

export default function PostsGrid({
  displayPosts,
  labels,
  currentLang,
  pagination,
  selectedCategory,
  onPageChange,
}: PostsGridProps) {
  const visiblePosts = displayPosts;

  return (
    <div className='flex flex-col justify-between w-full'>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full'>
        {visiblePosts.map((post, index) => {

          return (
            <div key={post.id} className='flex flex-col'>
              <div className='flex flex-col flex-grow justify-between'>
                <Link
                  href={currentLang === 'ru' ? `/posts/ru/${post.slug}` : `/posts/${post.slug}`}
                  className='block overflow-hidden'
                  prefetch={true}
                >
                  <div className='h-50 rounded-md border bg-white overflow-hidden'>
                    <div className='relative h-full w-full'>
                      {post.acf?.video_file ? (
                        <video
                          width='100%'
                          height='100%'
                          controls
                          className='rounded-md overflow-hidden object-cover w-full h-full'
                        >
                          <source src={post.acf.video_file} type='video/mp4' />
                        </video>
                      ) : post.acf?.youtube ? (
                        <iframe
                          src={`https://www.youtube.com/embed/${(() => {
                            const match = post.acf.youtube.match(
                              /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
                            );
                            return match?.[1] || '';
                          })()}`}
                          title={post.title.rendered}
                          className='object-cover w-full h-full'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                        />
                      ) : post.acf?.thumbnail?.url ? (
                        <Image
                          src={post.acf.thumbnail.url}
                          alt={post.title.rendered}
                          width={600}
                          height={375}
                          className='p-1 object-contain w-full h-full'
                          sizes='(max-width: 768px) 100vw, 33vw'
                          priority={index < 3}
                        />
                      ) : (
                        <div className='w-full h-full bg-gray-200 flex items-center justify-center'>
                          <span className='text-gray-500'>
                            {labels.noVideo}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <h2
                      className='text-base font-semibold mt-4 mb-2 line-clamp-2'
                      dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                    />
                    <div
                      className='text-zinc-500 text-base [&_*]:font-normal line-clamp-3'
                      dangerouslySetInnerHTML={{
                        __html:
                          post.content.rendered || 'No description available',
                      }}
                    />
                  </div>
                </Link>
                <div className='flex mt-2 justify-between items-center'>
                  <Link
                    href={currentLang === 'ru' ? `/posts/ru/${post.slug}` : `/posts/${post.slug}`}
                    className='flex flex-row gap-1 items-center text-accent-blue'
                  >
                    {labels.readMore}
                    <PiArrowRight size={14} />
                  </Link>

                  <a
                    href={post?.acf?.link_to_darpiano_sample || '#'}
                    className=' text-accent-blue'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {labels.practice}
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination */}
      {pagination && pagination.totalPages > 1 && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          totalPosts={pagination.totalPosts}
          hasNextPage={pagination.hasNextPage}
          hasPreviousPage={pagination.hasPreviousPage}
          currentLang={currentLang}
          selectedCategory={selectedCategory}
          onPageChange={onPageChange}
          labels={labels.pagination}
        />
      )}
    </div>
  );
}
